export default {
	assetLabel: 'Add asset connections',
	dataAssetLabel: 'Add data asset connections',
}
